import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { Navigation, Stock, Footer } from "./components";
import useToken from "./useToken.js";
import Login from "./components/Login/Login";
import Movements from "./components/Movements/Movements";
import Count from "./components/Count/Count";
import Shiplists from "./components/Shiplists/Shiplists";
import Enquiry from "./components/Enquiry/Enquiry";
import Picking from "./components/Picking/Picking.jsx";
import Receipt from "./components/Receipt/Receipt";

function App() {
  const { token, setToken } = useToken();

  if (token && token !== "q>)*8n[TfhTyZAW") {
    alert("Invalid Log-in Token");
    localStorage.removeItem("token");
  }

  if (!token) {
    return <Login setToken={setToken} />;
  }

  return (
    <div className="App">
      <Router>
        <Navigation />
        <Switch>
          <Route path="/" exact component={() => <Stock />} />
          <Route path="/stock" exact component={() => <Stock />} />
          <Route path="/movements" exact component={() => <Movements />} />
          <Route path="/count" exact component={() => <Count />} />
          <Route path="/shiplists" exact component={() => <Shiplists />} />
          <Route path="/enquiry" exact component={() => <Enquiry />} />
          <Route path="/picking" exact component={() => <Picking />} />
          <Route path="/receipt" exact component={() => <Receipt />} />
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}
export default App;
